/* ============================================================
   Lumera Header JS
   - Mobile drawer menu (drill-down)
   - Mobile full-screen search (empty -> loading -> results)
   - Desktop search (empty -> loading -> results)
   Real Shopify predictive search wired into both searches: products + collections.
   ============================================================ */

/* The mobile drawer is position:fixed, so move it out of the header section to
   the end of body; no ancestor with overflow or transform can then trap it. */
(function () {
    const drawer = document.querySelector('[data-lum-mobile-menu]');
    if (drawer && drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
    }
})();

/* ---------- Mobile drawer menu (drill-down) ---------- */
(function () {
    'use strict';
    var root = document.querySelector('[data-lum-mobile-menu]');
    if (!root) return;
    var body = root.querySelector('.lum-mobile-menu__body');
    var stack = ['0'];

    function panelByKey(key) {
        return key === '0'
            ? body.querySelector('[data-level="0"]')
            : body.querySelector('[data-panel="' + key + '"]');
    }
    function showOnly(key) {
        body.querySelectorAll('.lum-mobile-panel').forEach(function (p) { p.removeAttribute('data-active'); });
        var p = panelByKey(key);
        if (p) p.setAttribute('data-active', '');
    }
    document.querySelectorAll('[data-lum-open-menu]').forEach(function (btn) {
        btn.addEventListener('click', function () { root.setAttribute('data-drawer-open', ''); stack = ['0']; showOnly('0'); });
    });
    root.querySelectorAll('[data-lum-close-menu]').forEach(function (btn) {
        btn.addEventListener('click', function () { root.removeAttribute('data-drawer-open'); });
    });
    body.addEventListener('click', function (e) {
        var open = e.target.closest('[data-open]');
        if (open) {
            var key = open.getAttribute('data-open');
            if (panelByKey(key)) { stack.push(key); showOnly(key); }
            return;
        }
        if (e.target.closest('[data-back]') && stack.length > 1) {
            stack.pop(); showOnly(stack[stack.length - 1]);
        }
    });
})();


/* ---------- Shared: strip Shopify search tracking params from result links ---------- */
/* Removes _pos, _psq, _psid, _sid, _ss and _v; any other query param (e.g. variant) is kept. */
function lumCleanSearchUrl(url) {
    try {
        var u = new URL(url, window.location.origin);
        ['_pos', '_psq', '_psid', '_sid', '_ss', '_v'].forEach(function (key) { u.searchParams.delete(key); });
        return u.pathname + u.search + u.hash;
    } catch (e) {
        return url;
    }
}

/* ---------- Shared: open the full search results page for a query ---------- */
function lumGoToSearch(query) {
    var v = (query || '').trim();
    if (!v) return;
    window.location.href = '/search?q=' + encodeURIComponent(v) + '&type=product';
}

/* ---------- Shared: how many collections the dropdown shows ---------- */
var LUM_COLLECTION_LIMIT = 6;


/* ---------- Shared: render collections as rows above the product list ---------- */
function lumRenderCollections(collections, collectionsBox) {
    if (!collectionsBox) return;
    collectionsBox.innerHTML = '';

    var block = collectionsBox.closest('[data-search-collections-block]');
    var shown = collections.slice(0, LUM_COLLECTION_LIMIT);
    if (block) block.hidden = shown.length === 0;

    shown.forEach(function (c) {
        var link = document.createElement('a');
        link.className = 'lum-search__result';
        link.href = lumCleanSearchUrl(c.url);

        var thumb = document.createElement('span');
        thumb.className = 'lum-search__thumb';

        /* The suggest endpoint has used more than one shape for the collection image */
        var imgSrc = '';
        if (c.featured_image && c.featured_image.url) {
            imgSrc = c.featured_image.url;
        } else if (c.image) {
            imgSrc = c.image.url || c.image;
        }

        if (imgSrc) {
            var img = document.createElement('img');
            img.src = imgSrc;
            img.alt = c.title;
            img.width = 40;
            img.height = 40;
            thumb.appendChild(img);
        } else {
            var icon = document.createElement('i');
            icon.className = 'lum-icon lum-icon--cube lum-icon--md';
            thumb.appendChild(icon);
        }

        var info = document.createElement('span');

        var kind = document.createElement('span');
        kind.className = 'lum-search__result-kind';
        kind.textContent = 'Collection';

        var title = document.createElement('span');
        title.className = 'lum-search__result-title';
        title.textContent = c.title;

        info.appendChild(kind);
        info.appendChild(document.createElement('br'));
        info.appendChild(title);

        link.appendChild(thumb);
        link.appendChild(info);
        collectionsBox.appendChild(link);
    });
}


/* ---------- Shared: fetch products + collections from Shopify predictive search ---------- */
function lumFetchResults(query, resultsBox, collectionsBox, done) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each';
    fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
            var results = (data.resources && data.resources.results) || {};
            var products = results.products || [];
            lumRenderCollections(results.collections || [], collectionsBox);
            if (!resultsBox) { done(); return; }

            resultsBox.innerHTML = '';

            if (products.length === 0) {
                var empty = document.createElement('p');
                empty.style.padding = '12px';
                empty.style.color = '#999';
                empty.textContent = 'No products found';
                resultsBox.appendChild(empty);
                done();
                return;
            }

            products.forEach(function (p) {
                var link = document.createElement('a');
                link.className = 'lum-search__result';
                link.href = lumCleanSearchUrl(p.url);

                var thumb = document.createElement('span');
                thumb.className = 'lum-search__thumb';
                if (p.featured_image) {
                    var img = document.createElement('img');
                    img.src = p.featured_image.url;
                    img.alt = p.title;
                    img.width = 40;
                    img.height = 40;
                    thumb.appendChild(img);
                } else {
                    var icon = document.createElement('i');
                    icon.className = 'lum-icon lum-icon--cube lum-icon--md';
                    thumb.appendChild(icon);
                }

                var info = document.createElement('span');

                var kind = document.createElement('span');
                kind.className = 'lum-search__result-kind';
                kind.textContent = p.type ? p.type : 'Product';

                var title = document.createElement('span');
                title.className = 'lum-search__result-title';
                title.textContent = p.title;

                info.appendChild(kind);
                info.appendChild(document.createElement('br'));
                info.appendChild(title);

                link.appendChild(thumb);
                link.appendChild(info);
                resultsBox.appendChild(link);
            });

            done();
        })
        .catch(function () { done(); });
}


/* ---------- Mobile full-screen search: open/close + real results ---------- */
(function () {
    'use strict';
    var box = document.querySelector('[data-msearch]');
    if (!box) return;
    var input = box.querySelector('[data-msearch-input]');
    var clear = box.querySelector('[data-msearch-clear]');
    var terms = box.querySelectorAll('[data-msearch-term]');
    var resultsBox = box.querySelector('[data-panel="results"] [data-search-results]') ||
        box.querySelector('[data-search-results]');
    var collectionsBox = box.querySelector('[data-search-collections]');
    var timer = null;

    function setState(s) { box.setAttribute('data-state', s); }

    document.querySelectorAll('[data-lum-open-search]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            box.setAttribute('data-open', '');
            setState(input.value.trim() ? 'results' : 'empty');
            input.focus();
        });
    });
    box.querySelectorAll('[data-msearch-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { box.removeAttribute('data-open'); });
    });
    input.addEventListener('input', function () {
        clearTimeout(timer);
        var v = input.value.trim();
        if (!v) { setState('empty'); return; }
        setState('loading');
        timer = setTimeout(function () {
            terms.forEach(function (t) { t.textContent = v; });
            lumFetchResults(v, resultsBox, collectionsBox, function () { setState('results'); });
        }, 300);
    });
    clear.addEventListener('click', function () { input.value = ''; setState('empty'); input.focus(); });

    /* See all button and Enter both open the full results page with the typed query */
    var seeAll = box.querySelector('[data-search-see-all]');
    if (seeAll) {
        seeAll.addEventListener('click', function () { lumGoToSearch(input.value); });
    }
    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.isComposing) {
            e.preventDefault();
            lumGoToSearch(input.value);
        }
    });
})();


/* ---------- Desktop search: empty -> loading -> results (real Shopify) ---------- */
(function () {
    'use strict';
    var wrap  = document.querySelector('[data-search]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-search-input]');
    var clear = wrap.querySelector('[data-search-clear]');
    var terms = wrap.querySelectorAll('[data-search-term]');
    var resultsBox = wrap.querySelector('[data-panel="results"] [data-search-results]') ||
        wrap.querySelector('[data-search-results]');
    var collectionsBox = wrap.querySelector('[data-search-collections]');
    var timer = null;
    function setState(s) { wrap.setAttribute('data-state', s); }

    input.addEventListener('focus', function () {
        setState(input.value.trim() ? 'results' : 'empty');
        document.body.classList.add('lum-search-open');   // overlay + scroll lock + block megamenu
    });
    input.addEventListener('input', function () {
        clearTimeout(timer);
        var v = input.value.trim();
        if (!v) { setState('empty'); return; }
        setState('loading');
        timer = setTimeout(function () {
            terms.forEach(function (t) { t.textContent = v; });
            lumFetchResults(v, resultsBox, collectionsBox, function () { setState('results'); });
        }, 300);
    });

    
    clear.addEventListener('click', function () { input.value = ''; setState('empty'); input.focus(); });

    /* See all button and Enter both open the full results page with the typed query */
    var seeAll = wrap.querySelector('[data-search-see-all]');
    if (seeAll) {
        seeAll.addEventListener('click', function () { lumGoToSearch(input.value); });
    }
    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.isComposing) {
            e.preventDefault();
            lumGoToSearch(input.value);
        }
    });

    document.addEventListener('click', function (e) {

        if (!wrap.contains(e.target)) {
            wrap.removeAttribute('data-state');
            document.body.classList.remove('lum-search-open');
        }
    });
    /* Escape also closes the search overlay */
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && document.body.classList.contains('lum-search-open')) {
            wrap.removeAttribute('data-state');
            document.body.classList.remove('lum-search-open');
            input.blur();
        }
    });
    /* Keyboard: tabbing out of the search closes it, so the page is never left locked */
    wrap.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !wrap.contains(e.relatedTarget)) {
            wrap.removeAttribute('data-state');
            document.body.classList.remove('lum-search-open');
        }
    });
})();

/* ---------- Publish the sticky header height for anchor and focus offsets ---------- */
(function () {
    'use strict';
    var header = document.querySelector('.lum-header');
    if (!header || !('ResizeObserver' in window)) return;
    /* The sticky element is the section wrapper, not the inner header */
    var sticky = header.closest('.shopify-section') || header;
    var root = document.documentElement;
    new ResizeObserver(function () {
        root.style.setProperty('--lum-header-h', sticky.offsetHeight + 'px');
    }).observe(sticky);
})();